import { Body1, Body1Strong, Body2, Subtitle2 } from '@fluentui/react-components';
import { Avatar, useUsers } from '@modules/users';
import { TFindingComment } from '../../types';

export const FindingComments = ({ comments = [] }: { comments?: TFindingComment[] }) => {
  const { users } = useUsers();
  if (!comments.length) return null;

  return (
    <div className="flex flex-col gap-4">
      <Subtitle2>Comments</Subtitle2>
      {comments.map((comment) => {
        const author = users?.find((user) =>
          comment.authorId
            ? user._id === comment.authorId
            : user.name === comment.author || user.mail === comment.author
        );
        return (
          <div key={comment.id} className="flex items-start gap-3">
            <Avatar user={author} name={comment.author} size={28} />
            <div className="flex flex-col gap-1 min-w-0">
              <div className="flex flex-wrap items-center gap-3">
                <Body1Strong>{comment.author}</Body1Strong>
                <Body1 className="text-neutralFg-3">
                  {new Date(comment.createdAt).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })}
                </Body1>
              </div>
              <Body2 className="whitespace-pre-wrap break-words [overflow-wrap:anywhere]">{comment.text}</Body2>
            </div>
          </div>
        );
      })}
    </div>
  );
};
